import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';

@Component<AirlineCreditInfoOverlay>({
  components: ({})
})
export default class AirlineCreditInfoOverlay extends Vue {
  public modalTitle="Important information about credit";
  public modalId="credit-info-modal";

  public constructor() {
    super();
  }

  public mounted() {
    console.log('mounted');
    this.show();
    return true;
  }

  public created() {
    return true;
  }

  public destroyed() {
    return true;
  }

  public updated() {
    return true;
  }

  public show(){
    console.log('showing');
    this.$bvModal.show(this.modalId);
  }

  public hide(){
    this.$bvModal.hide(this.modalId);
  }

  public onOkBtnClick(){
    this.$emit('credit-info-accepted', true);
    this.$bvModal.hide(this.modalId);
  }
}
